import { Reveal, Chapter } from "@/components/Reveal";

const STEPS = [
  { num: "01", title: "Vos besoins", desc: "Nous déterminons exactement ce que vous recherchez." },
  { num: "02", title: "Nous recherchons", desc: "Nous analysons les véhicules disponibles et trouvons les meilleures options." },
  { num: "03", title: "Nous négocions", desc: "Nous travaillons à obtenir les meilleures conditions possibles." },
  { num: "04", title: "Nous coordonnons", desc: "Inspection, financement, documents, livraison et autres étapes sont coordonnés." },
  { num: "05", title: "Vous profitez", desc: "Vous récupérez votre véhicule sans avoir eu à gérer toutes les démarches." },
];

export default function Process() {
  return (
    <section id="processus" data-testid="process-section" className="py-24 md:py-32 lg:py-40">
      <div className="container-x">
        <Reveal>
          <Chapter number="08" label="Le processus" />
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[1.1] tracking-tight mb-16">
            Comment ça <span className="gold-text">fonctionne.</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-5 gap-4 lg:gap-6">
          {STEPS.map((s, i) => (
            <Reveal key={s.num} delay={0.1 * i}>
              <div
                data-testid={`process-step-${s.num}`}
                className="relative h-full border border-white/10 rounded-xl p-7 bg-chiseled/60 hover:border-gold/40 transition-colors duration-500 group"
              >
                <span className="font-mono text-4xl lg:text-5xl text-white/10 group-hover:text-gold/25 transition-colors duration-500 block mb-6">
                  {s.num}
                </span>
                <h3 className="text-sm uppercase tracking-[0.15em] text-white font-semibold mb-3">{s.title}</h3>
                <p className="text-[13px] text-slate-400 font-light leading-relaxed">{s.desc}</p>
                {i < STEPS.length - 1 && (
                  <span className="hidden md:block absolute top-1/2 -right-3 w-6 h-px bg-gold/30" />
                )}
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
